module.exports = __webpack_public_path__ + "f11640bf511d4c9258ef213f9c2caf2a.png";